import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

/**
 * Directive to globally disable browser autofill on all input and textarea elements.
 * This helps prevent the browser's native autocomplete from overlapping custom UI components.
 */
@Directive({
    // tslint:disable-next-line: directive-selector
    selector: 'input, textarea'
})
export class DisableAutofillDirective implements OnInit {

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    ngOnInit() {
        // Set autocomplete to 'off' or a non-standard value to bypass aggressive browser autofill
        // 'chrome-off' is often more effective than 'off' in recent Chrome versions
        this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', 'chrome-off');
    }
}
